
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 504.161 504.161"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M344.131 268.867a8.393 8.393 0 00-8.393 8.393v201.443a8.393 8.393 0 01-8.393 8.393H25.18a8.393 8.393 0 01-8.393-8.393V25.457a8.393 8.393 0 018.393-8.393h302.164a8.393 8.393 0 018.393 8.393v50.361a8.393 8.393 0 1016.786 0V25.457c0-13.907-11.274-25.18-25.18-25.18H25.18C11.274.277 0 11.551 0 25.457v453.246c0 13.907 11.274 25.18 25.18 25.18h302.164c13.907 0 25.18-11.274 25.18-25.18V277.261a8.392 8.392 0 00-8.393-8.394z"}}),_c('path',{attrs:{"d":"M491.869 28.793c-16.339-16.338-42.81-16.396-59.22-.13l.017-.008-55.262 55.254L88.433 372.896c-.084.076-.109.185-.185.26a8.33 8.33 0 00-1.595 2.367l-.067.143L51.04 458.61a8.393 8.393 0 007.714 11.701 8.303 8.303 0 003.307-.68l82.936-35.546.143-.067a8.135 8.135 0 002.367-1.595c.076-.076.185-.101.26-.185l288.978-288.961 55.254-55.262c16.266-16.411 16.208-42.883-.13-59.222zM74.702 445.969l22.461-52.409 29.948 29.948-52.409 22.461zm67.147-31.534l-35.613-35.613 277.11-277.101 35.605 35.605-277.102 277.109zm288.97-288.978l-35.605-35.605 13.707-13.715 35.613 35.613-13.715 13.707zm49.328-49.278l-.042-.008-23.745 23.745-35.571-35.647 23.745-23.703a25.183 25.183 0 0135.613 35.613zM276.984 75.818H75.541a8.393 8.393 0 100 16.786h201.443a8.393 8.393 0 100-16.786zM285.377 134.572a8.393 8.393 0 00-8.393-8.393H75.541a8.393 8.393 0 100 16.786h201.443a8.392 8.392 0 008.393-8.393zM75.541 176.539a8.393 8.393 0 100 16.786h151.082a8.393 8.393 0 100-16.786H75.541z"}})])
          )
        }
      }
    